import React, { useEffect, useRef, useState } from 'react';
import { FormControl, Input, InputAdornment, InputLabel } from '@mui/material';
import { Button, Dropdown } from 'react-bootstrap';
import { Search } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { getDataFromServer, postDatatoServer } from '../utils/apiBase';
import ContextHelper from '../ContextHooks/ContextHelper';
import toast from 'react-hot-toast';
import ColumnToggleTable from './ColumnToggleTable';
import DeleteModal from './DeleteModal';
import axios from 'axios';

function ExpandDropdown(props) {
  const {
    setPageSize,
    setCurrentPage,
    dashboardView,
    setUploadSuccess,
    columnVisibility,
    setColumnVisibility,
    columns,
    selectedRows,
    currentPage,
    setFilteredTableData,
    setIsLoading,
    pageSize,
    setCurrentData,
    tableData,
    historyData,
  } = props;
  const { currentUser } = ContextHelper();
  const [DoctorUsers, setDoctorUsers] = useState([]);
  const lengthMenu = [10, 20, 50, 100];
  const [isUrgentChecked, setIsUrgentChecked] = useState(false);
  const [isReportsChecked, setIsReportsChecked] = useState(false);
  const [showCompleteReports, setShowCompleteReports] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showTableColumns, setShowTableColumns] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [pendingAssignment, setPendingAssignment] = useState(null);

  const location = useLocation();
  const path = location.pathname;
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (historyData === '') {
      setHistoryModal(true);
    }
  }, [historyData, selectedRows, tableData]);

  useEffect(() => {
    setIsLoading(true);

    const filteredData = tableData.filter(
      (item) =>
        (item.name?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
          item.study?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
          item.location?.toLowerCase().includes(searchQuery?.toLowerCase())) &&
        (!isUrgentChecked || item.isUrgent) &&
        (!showCompleteReports || item.reports.length > 0) &&
        (isReportsChecked ? item.reports.length === 0 : true)
    );

    setFilteredTableData(filteredData);
    setCurrentData(filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize));
    setIsLoading(false);
  }, [searchQuery, currentPage, tableData, pageSize, isUrgentChecked, isReportsChecked, showCompleteReports]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowTableColumns(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const performAssignment = async (doctorName) => {
    if (currentUser?.isadmin && currentUser?.type !== 'Doctor') {
      try {
        const assignments = selectedRows.map(async (drRemark) => {
          const selectedItem = tableData.find((item) => item.id === drRemark);
          const historyForThisItem = selectedItem?.history || '';

          const response = await axios.post(
            'https://rad.iotcom.io/node/CaseAssign',
            {
              id: drRemark,
              doctorName: doctorName,
              history: historyForThisItem,
            },
            {
              headers: {
                Authorization: `Bearer ${currentUser?.token}`,
                'Content-Type': 'application/json',
              },
            }
          );

          const res = response.data;
          if (res.result1?.modifiedCount > 0) {
            toast.success(res.message);
            return res.message;
          } else {
            throw new Error(res.message);
          }
        });

        await Promise.all(assignments);
        setUploadSuccess(true);
      } catch (error) {
        console.error('Assignment error:', error);
        toast.error(error.message || 'Failed to assign cases');
      }
    } else {
      toast.error('You are not authorized to assign cases');
    }
  };

  const DropdownClicked = async (doctorName) => {
    const hasEmptyHistory = selectedRows.some((rowId) => {
      const selectedItem = tableData.find((item) => item.id === rowId);
      const historyForThisItem = selectedItem?.history || '';
      return historyForThisItem === '';
    });

    if (hasEmptyHistory) {
      setPendingAssignment(doctorName);
      setHistoryModal(true);
    } else {
      await performAssignment(doctorName);
    }
  };
  const handleModalConfirm = async () => {
    // User confirmed to proceed with assignment even with empty history
    if (pendingAssignment) {
      await performAssignment(pendingAssignment);
      setPendingAssignment(null);
    }
    setHistoryModal(false);
  };

  const handleModalClose = () => {
    // User cancelled the assignment
    setPendingAssignment(null);
    setHistoryModal(false);
  };

  useEffect(() => {
    const fetchDoctorData = () => {
      const ApiUrl = 'DoctorUsers';

      const handleResponse = (res) => {
        if (res.status === 'success') {
          setDoctorUsers(res.response);
        }
      };

      const handleError = (error) => {
        console.error(error);
      };

      const params = {
        end_point: ApiUrl,
        params: { token: currentUser?.token },
        call_back: handleResponse,
        props: '',
      };

      getDataFromServer(params)
        .catch(handleError)
        .finally(() => console.log());
    };

    fetchDoctorData();
  }, []);

  const handleCheckboxChange = (event) => {
    setIsUrgentChecked(event.target.checked);
    setCurrentPage(1);
  };

  const handleCompleteReports = (event) => {
    setShowCompleteReports(event.target.checked);
    setCurrentPage(1);
  };

  return (
    <>
      {(showTableColumns && (
        <ColumnToggleTable
          columnsData={columns}
          dropdownRef={dropdownRef}
          setShowTableColumns={setShowTableColumns}
          columnVisibility={columnVisibility}
          setColumnVisibility={setColumnVisibility}
        />
      )) ||
        ''}

      <DeleteModal
        deleteModal={historyModal}
        handleDeleteReport={handleModalConfirm}
        closeModal={handleModalClose}
        text={
          'This case  will be not be downloaded in dropbox because history is not updated. Are you sure you want to assign the case to doctor without updating history.'
        }
        history={true}
      />

      <div className="d-flex align-items-end gap mb-3 flex-wrap">
        <div className="form-check">
          <input
            className="form-check-input border cursor-pointer"
            type="checkbox"
            value=""
            id="completereport"
            checked={showCompleteReports}
            onChange={handleCompleteReports}
          />
          <label className="form-check-label fs-16 fw-semibold user-select cursor-pointer" htmlFor="completereport">
            Complete Reports
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input border cursor-pointer"
            type="checkbox"
            value=""
            id="report"
            checked={isReportsChecked}
            onChange={() => setIsReportsChecked(!isReportsChecked)}
          />
          <label className="form-check-label fs-16 fw-semibold user-select cursor-pointer" htmlFor="report">
            Pending Reports
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input border cursor-pointer"
            type="checkbox"
            value=""
            id="urgent"
            checked={isUrgentChecked}
            onChange={handleCheckboxChange}
          />
          <label className="form-check-label fs-16 fw-semibold user-select cursor-pointer" htmlFor="urgent">
            Urgent Reports
          </label>
        </div>
        {!dashboardView && (
          <>
            <div className="search-bar">
              <FormControl fullWidth variant="standard">
                <InputLabel htmlFor="search" className="fs-14">
                  Search here
                </InputLabel>
                <Input
                  id="search"
                  name="search"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                  value={searchQuery}
                  type="text"
                  endAdornment={
                    <InputAdornment position="end">
                      <Search />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>

            <div className="form-group text-nowrap fs-14">
              Show{' '}
              <select
                className="border rounded-3 cursor-pointer px-2 py-2 mx-1 bg-white text-center fs-14"
                onChange={(e) => {
                  setPageSize(e.target.value);
                  setCurrentPage(1);
                }}
              >
                {lengthMenu.map((item, key) => {
                  return (
                    <option key={key} defaultValue={key == 0} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
              Entries
            </div>

            <div className="form-group text-nowrap">
              {path === '/add-report' && (
                <Dropdown>
                  <Dropdown.Toggle variant="" className="base-color-bg text-white border-0 fs-15" id="dropdown-basic">
                    Assign Cases
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="w-100 text-center">
                    {DoctorUsers &&
                      DoctorUsers.map((doctor, index) => (
                        <Dropdown.Item
                          key={index}
                          className="bg-white"
                          onClick={() => DropdownClicked(doctor.username)}
                        >
                          {doctor.username}
                        </Dropdown.Item>
                      ))}
                    <Dropdown.Item className="bg-white" onClick={() => DropdownClicked('Admin')}>
                      Unassign
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </>
        )}
        <Button
          variant=""
          ref={buttonRef}
          className="login-btn base-color-bg fs-15 text-white fw-semibold ms-auto"
          onClick={() => setShowTableColumns(!showTableColumns)}
        >
          Filters
        </Button>
      </div>
    </>
  );
}

export default ExpandDropdown;
